<template>

</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        islink: {
            type: Boolean,
            default: true,
        },
    },
    components: {

    },
    data () {
        return {

        }
    },
    methods: {
        backUp () {
            var that = this;
            that.$router.go(-1);
        }
    }

}
</script>
<style lang="scss">
</style>





// WEBPACK FOOTER //
// src/components/header.vue